// #region Global Imports
import * as React from 'react';
import isEmpty from 'lodash/isEmpty';
// #endregion Global Imports
// #region Local Imports
import { gql } from '@generated/gql';
import type { FragmentType } from '@generated/fragment-masking';
import { getFragmentData } from '@generated/fragment-masking';
import type { ParagraphFragment } from '@components/Paragraphs/Paragraph';
import { Paragraph } from '@components/Paragraphs/Paragraph';
import type { IProps } from '@components/Paragraphs/Paragraphs.d';
// #endregion Local Imports

export const ParagraphsPageFragment = gql(/* GraphQL */ `
  fragment ParagraphsPageFragment on NodePage {
    paragraphs: fieldContent {
      entity {
        uuid: entityUuid
        ...ParagraphFragment
      }
    }
  }
`);

export const ParagraphsPostFragment = gql(/* GraphQL */ `
  fragment ParagraphsPostFragment on NodePost {
    paragraphs: fieldContent {
      entity {
        uuid: entityUuid
        ...ParagraphFragment
      }
    }
  }
`);

export const Paragraphs: React.FunctionComponent<IProps.Paragraphs> = ({
  entity,
}) => {
  const paragraphs = getFragmentData(
    ParagraphsPostFragment,
    entity,
  )?.paragraphs;

  return (
    <div>
      {!isEmpty(paragraphs)
        ? paragraphs?.map((paragraph) => (
            <Paragraph
              key={String(paragraph?.entity?.uuid)}
              paragraph={
                paragraph?.entity as FragmentType<typeof ParagraphFragment>
              }
            />
          ))
        : null}
    </div>
  );
};
